import React from "react";
import "./styles.scss";
import {
  Button,
  ButtonColour,
  ButtonSize,
  Typography
} from "@trussle/external-components";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { IContentfulHeroProps } from "../../types/IHero";
import { PanelWrapper } from "../PanelWrapper";

import { trackEvent } from "../../helpers/analytics";
import { getPlainText } from "../../utils/getPlainText";
import { Checklist } from "../Checklist";
import { TrustpilotScore } from "../TrustpilotScore";
import BrowserSVG from "../../static/browser.svg";
import MobileSVG from "../../static/mobile.svg";

const defaultCtaUrl = "https://bettercouk.links.nivohub.com/l/efr";
const defaultSecondCtaUrl = "https://better.co.uk/account/signup/purchase-research";

export const HeroMobileDownload: React.FC<IContentfulHeroProps> = ({
  heading1,
  firstCta,
  secondCta,
  bullets,
  imageFullWidth: backgroundImageLeft,
  imageMobile: backgroundImageRight,
  trustpilotIconLink
}) => {
  const onButtonClick = async () => {
    await trackEvent("FirstCta clicked", {
      module: "heroMobileDownload",
      element_type: "Button",
      section: "Hero"
    });
    window.location.assign(firstCta?.url || defaultCtaUrl);
  };
  const onSecondButtonClick = async () => {
    await trackEvent("SecondCta clicked", {
      module: "heroMobileDownload",
      element_type: "Button",
      section: "Hero"
    });
    window.location.assign(secondCta?.url || defaultSecondCtaUrl);
  };
  const leftImage = getImage(backgroundImageLeft!)!;
  const rightImage = getImage(backgroundImageRight!)!;
  return (
    <PanelWrapper isBetterV2 hideOverflow>
      <div className="heroMobileDownload">
        <div className="heroMobileDownload__content">
          {heading1 && (
            <Typography variant="h1" component="h1" classes="heroMobileDownload__heading">
              {getPlainText(heading1)}
            </Typography>
          )}
          <div className="heroMobileDownload__bullet__list">
            <Checklist bullets={bullets} />
          </div>
          <div className="heroMobileDownload__ctas_group">
            <div className="heroMobileDownload__cta_group">
              <div className="heroMobileDownload__cta_text_group">
                <img src={BrowserSVG} alt="browser icon" className="" loading="lazy" />
                <div>
                  <span className="heroMobileDownload__cta_first_text_subtitle">
                    {firstCta?.subtitle}
                  </span>
                  <span className="heroMobileDownload__cta_first_text_description">
                    {" "}
                    {firstCta?.description}
                  </span>
                </div>
              </div>
              <Button
                onClick={onButtonClick}
                fixed
                colour={ButtonColour.DarkGreen}
                className="heroMobileDownload__cta_left"
                size={ButtonSize.Large}
              >
                {firstCta?.title}
                <GatsbyImage
                  className="heroMobileDownload__image_left"
                  image={leftImage}
                  alt={backgroundImageLeft!.title}
                  objectFit="contain"
                />
              </Button>
            </div>
            {secondCta && (
              <div className="heroMobileDownload__cta_group">
                <div className="heroMobileDownload__cta_text_group">
                  <img src={MobileSVG} alt="browser icon" className="" loading="lazy" />
                  <div>
                    <span className="heroMobileDownload__cta_second_text_subtitle">
                      {secondCta?.subtitle}
                    </span>
                    <span className="heroMobileDownload__cta_second_text_description">
                      {" "}
                      {secondCta?.description}
                    </span>
                  </div>
                </div>
                <Button
                  onClick={onSecondButtonClick}
                  fixed
                  colour={ButtonColour.DarkYellow}
                  className="heroMobileDownload__cta_right"
                  size={ButtonSize.Large}
                >
                  {secondCta?.title}
                  <GatsbyImage
                    className="heroMobileDownload__image_right"
                    image={rightImage}
                    alt={backgroundImageRight!.title}
                    objectFit="contain"
                  />
                </Button>
              </div>
            )}
          </div>

          <a
            className="heroMobileDownload__trustpilot"
            href={trustpilotIconLink?.url}
            aria-label="trustpilot"
          >
            <TrustpilotScore />
          </a>
        </div>
      </div>
    </PanelWrapper>
  );
};

/*
        <div
          className="heroMobileDownload__image"
          onClick={onImageClick}
          onKeyDown={onImageClick}
          role="button"
          tabIndex={0}
          aria-label="app image"
        >
          <GatsbyImage
            image={images}
            alt={imageFullWidth!.title}
            objectFit="contain"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
*/
